<template>
    <input :autocomplete="autocomplete" :class="['p-inputtext p-component', {'p-filled': filled}]" :value="modelValue"
           v-bind="$attrs" @input="onInput"/>
</template>

<script>
import InputText from "primevue/inputtext";

export default {
    name: "InputText",
    props: {
        autocomplete: null,
    },
    extends: InputText
}
</script>

<style scoped>

</style>